import { render } from "./ProfileForum.vue?vue&type=template&id=2a7cd500"
import script from "./ProfileForum.vue?vue&type=script&lang=js"
export * from "./ProfileForum.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/d/git/workshop/social-friendsquads/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__